export const AVAILABILITY_TYPE = {
    FULLY_AVAILABLE: 'FULLY_AVAILABLE',
    NOT_AVAILABLE: 'NOT_AVAILABLE',
};
